import api from './api';

export const getOffers = async (page = 1, limit = 10, includeExpired = false, category = null, subcategory = null, brand = null) => {
  let url = `/offers?page=${page}&limit=${limit}`;
  if (includeExpired) {
    url += `&includeExpired=true`;
  }
  if (category) {
    url += `&category=${category}`;
  }
  if (subcategory) {
    url += `&subcategory=${subcategory}`;
  }
  if (brand) {
    url += `&brand=${brand}`;
  }
  const response = await api.get(url);
  return response.data;
};

// Get offers by brand
export const getOffersByBrand = async (brandId, page = 1, limit = 10, includeExpired = false) => {
  let url = `/offers/by-brand/${brandId}?page=${page}&limit=${limit}`;
  if (includeExpired) {
    url += `&includeExpired=true`;
  }
  const response = await api.get(url);
  return response.data;
};

// Get offers by specific subcategory
export const getOffersBySubcategory = async (categoryId, subcategoryId, page = 1, limit = 10, includeExpired = false) => {
  let url = `/offers/by-subcategory/${categoryId}/${subcategoryId}?page=${page}&limit=${limit}`;
  if (includeExpired) {
    url += `&includeExpired=true`;
  }
  const response = await api.get(url);
  return response.data;
};

// Get offers grouped by categories and subcategories
export const getOffersByCategories = async (includeExpired = false) => {
  let url = `/offers/by-categories`;
  if (includeExpired) {
    url += `?includeExpired=true`;
  }
  const response = await api.get(url);
  return response.data;
};

export const getOfferBySlug = async (slug) => {
  const response = await api.get(`/offers/${slug}`);
  return response.data;
};

export const getOfferById = async (id) => {
  const response = await api.get(`/offers/id/${id}`);
  return response.data;
};

export const createOffer = async (offerData) => {
  const response = await api.post('/offers', offerData);
  return response.data;
};

// Create offer from template with subcategory
export const createOfferFromTemplate = async (templateId, offerData) => {
  const response = await api.post(`/offers/from-template/${templateId}`, offerData);
  return response.data;
};

export const updateOffer = async (id, offerData) => {
  const response = await api.put(`/offers/${id}`, offerData);
  return response.data;
};

export const deleteOffer = async (id) => {
  const response = await api.delete(`/offers/${id}`);
  return response.data;
}; 